import { gate } from 'hub-http/gates';
import { userInfoSync } from 'hub-http/userInfo';
export const Gates = {
  BREEZE_AI_REBRANDING: gate('BreezeAI:Rebranding'),
  GO_TO_WEBINAR_COMPONENT_MIGRATION: gate('GoToWebinar:FormSubmission:ComponentMigration'),
  FIELD_LARGE_LABEL_DEFAULT: gate('CMS:FieldLargeLabelDefault')
};
export const isUngatedFor = gateName => {
  try {
    const auth = userInfoSync();
    return auth.gates.includes(gateName);
  } catch (err) {
    return false;
  }
};